export const ERROR_MESSAGES: Record<string, string> = {
  USER_NOT_FOUND: "Пользователь не найден",
  USER_HAS_NO_COMPANY: "У пользователя нет компании",
  VACANCY_COMPANY_CODE_ALREADY_EXISTS: "Код компании вакансии уже существует",
  USER_WITH_EMAIL_EXIST: "Пользователь с таким email уже существует в нашем списке пользователей",
  EMESSAGE: "Кандидат был создан. Но email не активный или не корректен"
};

export const getErrorMessage = (error: any): string => {
  const errorCode = error?.response?.data?.message?.code || error?.response?.data?.message;
  return ERROR_MESSAGES[errorCode] || `Ошибка: ${error?.message || "Неизвестная ошибка"}`;
};